module.exports = __webpack_public_path__ + "ui-select.7f7db3a9.mp3";